import CookiePolicy1 from '../assets/cookie-policy-1.png';
import CookiePolicy2 from '../assets/cookie-policy-2.png';
import CookiePolicy3 from '../assets/cookie-policy-3.png';
import CookiePolicy4 from '../assets/cookie-policy-4.png';
import BannerDesktop from '../assets/cookie-policy-desktop.png';
import BannerMobile from '../assets/cookie-policy-mobile.png';
import { ContentSection } from '../components/content-section';
import { Layout } from '../components/page-layout';
import { Picture } from '../components/picture';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 1.5rem;
`;
const BannerImgMobile = styled.img`
  display: block;
  width: 100%;
  @media (min-width: 768px) {
    display: none;
  }
`;
const BannerImgDesktop = styled.img`
  display: none;
  width: 100%;
  @media (min-width: 768px) {
    display: block;
  }
`;
const Title = styled.h1`
  font-size: 1.875rem;
  font-weight: bold;
  margin-top: 3rem;
`;
const SubText = styled.div`
  font-size: 0.875rem;
  color: #4b5563;
  margin-top: 1.5rem;
`;
const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;
const PictureCol = styled.div`
  display: none;
  flex-direction: column;
  margin-right: 2.25rem;
  margin-bottom: 2rem;
  @media (min-width: 768px) {
    display: flex;
  }
`;
const PictureRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0;
  & + & {
    margin-top: 1rem;
  }
`;
const StyledPicture = styled(Picture)`
  min-width: 304px;
  & + & {
    margin-left: 2rem;
  }
`;
const HighlightSection = styled.div`
  padding: 1.5rem;
  margin-top: 3rem;
  background: #F87B15;
  color: #fff;
  border-radius: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const HighlightText = styled.p`
  text-align: center;
  color: #fff;
  line-height: 1.5;
`;


const HighlightButton = styled.a`
  background: #fff;
  color: #F87B15;
  border-radius: 9999px;
  padding: 0.5rem 2rem;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  font-size: 1rem;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #ffe3d0;
    color: #d65c00;
  }
`;

export default function CookiePolicy() {
  return (
    <Layout showCommonFooter={true}>
      <Container>
        <BannerImgMobile src={BannerMobile} alt="Cookie Policy Banner" />
        <BannerImgDesktop src={BannerDesktop} alt="Cookie Policy Banner" />
        <Title>SENSFORGE COOKIE POLICY</Title>
        <SubText>Effective Date: Jan 1st 2025</SubText>
        <ContentSection title="1. Introduction" className="mt-6">
          <p>
            Sensforge Inc. and its subsidiaries (collectively, “Sensforge”,
            “we”, or “our”) are committed to safeguarding your privacy. We
            utilize cookies and similar tracking technologies to enhance your
            experience on our websites, services, mobile sites, and applications
            (collectively, the “Sites”). This Cookie Policy outlines the types
            of cookies we use, their purposes, and how you can manage them. For
            detailed information on our data protection practices, please refer
            to our Privacy Notice.
          </p>
        </ContentSection>
        <ContentSection
          title="2. What Are Cookies and Similar Technologies?"
          className="mt-6"
        >
          <p>
            Cookies are small text files placed on your device to store data
            that can be recalled by a web server in the domain that placed the
            cookie. We also use web beacons, pixels, and other tracking
            technologies that function similarly to cookies. These technologies
            help us collect information about your interactions with our Sites
            and emails, such as IP address, browser type, and pages visited.
          </p>
        </ContentSection>
        <FlexRow>
          <PictureCol>
            <PictureRow>
              <StyledPicture src={CookiePolicy1} />
              <StyledPicture src={CookiePolicy2} />
            </PictureRow>
            <PictureRow>
              <StyledPicture src={CookiePolicy3} />
              <StyledPicture src={CookiePolicy4} />
            </PictureRow>
          </PictureCol>
          <ContentSection
            title="3. How We Use Your Information"
            className="mt-6"
          >
            <p>We use the collected information to:</p>
            <ul>
              <li>Provide and improve our Services, including customer support and updates.</li>
              <li>Enhance security and prevent unauthorized use.</li>
              <li>Personalize your experience with relevant content and features.</li>
              <li>Communicate promotional offers, subject to your preferences.</li>
              <li>Comply with legal obligations.</li>
            </ul>
          </ContentSection>
        </FlexRow>
        <ContentSection title="4. Types of Cookies We Use" className="mt-6">
          <p>We use the collected information to:</p>
          <ul>
            <li>Essential Cookies: These cookies are necessary for the operation of our Sites. They enable core functionalities like security, network management, and accessibility. Without these cookies, services you have asked for cannot be provided.</li>
            <li>Performance and Analytics Cookies: These cookies collect information about how you use our Sites, such as which pages you visit most often and if you receive error messages. We use this data to improve the performance and design of our Sites.</li>
            <li>Functionality Cookies: These cookies allow our Sites to remember choices you make (such as your username, language, or the region you are in) and provide enhanced, more personalized features.</li>
            <li>Advertising and Targeting Cookies: We partner with third-party service providers that may use cookies and similar tracking technologies to collect information about your activities on our Sites and other websites to provide you with targeted advertising based on your interests.</li>
          </ul>
        </ContentSection>
        <ContentSection title="5. Third-Party Cookies" className="mt-6">
          <p>
            We may allow third parties to set cookies on your device for advertising and analytics purposes. These third parties may collect information about your online activities over time and across different websites. We do not control these third-party cookies and recommend that you review the privacy policies of these third parties for more information.
          </p>
        </ContentSection>
        <ContentSection title="6. Your Choices" className="mt-6">
          <p>
            You can manage your cookie preferences through your browser settings. Most web browsers allow you to control cookies through their settings preferences. If you choose to reject cookies, you may still use our Sites, but your access to some functionality and areas of our Sites may be restricted.
          </p>
        </ContentSection>
        <ContentSection
          title="7. Updates to This Cookie Policy"
          className="mt-6"
        >
          <p>
            We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We encourage you to review this policy periodically to stay informed about our use of cookies and related technologies.
          </p>
        </ContentSection>
        <HighlightSection>
          <HighlightText>
            For questions or concerns about this Cookie Policy,<br />
            please contact us at: <br />
            Email: legal@sensforge.com<br />
            Sensforge Inc.<br />
            639 Alpha Drive, Pittsburgh, PA 15238<br />
          </HighlightText>
          <HighlightButton
            href="mailto:legal@sensforge.com"
            type="button"
          >
            Contact Us
          </HighlightButton>
        </HighlightSection>
      </Container>
    </Layout>
  );
}
